<template>
	<div>
		<table class="datatable">
			<thead v-if="!isMobile">
			<th class="sortable active left" @click="sort('name')">
				Person
			</th>
			<th>
				Ordre antal
			</th>
			<th>
				Betalt
			</th>
			<th class="sortable" @click="sort('ordersum')">
				Total
			</th>
			<th class="sortable" @click="sort('orderslastchangedate')">
				Person/Ordre status
			</th>
			<th>
			</th>
			</thead>
			<tbody v-if="!isMobile">
				<template v-for="(person) in (sortedActivity, filteredList)">
					<tr v-bind:key="person.id" :data-personid="person.id" :class="{ 'multipleorders': person.ordercount > 0 }">
						<td @click.prevent="handlePersonOrders(person, $event)">
							{{ person.name }}
							<div class="small">
								{{ person.customername }}, {{ person.persongroupname }}
							</div>
						</td>
						<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-if="person.ordercount == 1">
							{{ person.ordercount }} ordre
							<div class="small">#IM-SF-{{ person.firstorderid }}</div>
						</td>
						<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-if="person.ordercount != 1">
							{{ person.ordercount }} ordrer
						</td>
						<td @click.prevent="handlePersonOrders(person, $event)" class="right">
							{{ getPayedPrice(person) }}
						</td>
						<td @click.prevent="handlePersonOrders(person, $event)" class="right">
							{{ getTotalPrice(person) }}
						</td>
						<td @click.prevent="handlePersonOrders(person, $event)" class="center" v-html="getPersonStatus(person)"></td>
						<td class="center" @click.prevent="addOrder(person)"><button class="small" style="padding: 0 8px;">Ny ordre</button></td>
					</tr>
					<template v-for="(order) in (person.orders)">
						<tr @click="gotoOrder(order, person.id)" v-bind:key="person.id + '-' + order.id" class="multipleorderslist" :data-personid="person.id">
							<td>
								#{{ order.ordernumber }}<br />
								{{ getOrderInfo(order) }}
							</td>
							<td></td>
							<td class="right">
								{{ order.totalprice }} kr.
								<div v-if="getOrderReminderFee(order) > 0" class="small">Rykkergebyr: {{ getOrderReminderFee(order) }}</div>
							</td>
							<td></td>
							<td class="center" v-html="getOrderStatus(order)"></td>
							<td></td>
						</tr>
					</template>
				</template>
			</tbody>
			<tbody v-else>
				<tr v-for="(person) in (sortedActivity, filteredList)" :key="person.id" @click.prevent="handlePersonOrders(person, $event)">
					<td>
						<ul class="flex-content">
							<li data-label="Navn"><span v-html="markSearchText(person.name, 'name')"></span></li>
							<li data-label="Ordre">{{ person.ordercount }} stk.</li>
							<li data-label="Betalt">{{ getPayedPrice(person) }}</li>
							<li data-label="Total">{{ getTotalPrice(person) }}</li>
							<li data-label="Status" v-html="getPersonStatus(person)"></li>
						</ul>
					</td>
				</tr>
			</tbody>
		</table>
		<div v-if="(data && data.length > 0) && (filteredList && filteredList.length == 0) && !isComponentBusy">
			Ingen personer fundet i gruppen.
		</div>
		<div v-if="(data == null || data.length == 0) && !isComponentBusy">
			Der er endnu ikke oprettet nogen personer i denne gruppe.
		</div>
		<transition name="fade">
			<div class="busyloader" v-if="isComponentBusy"><div><div></div><div></div><div></div><div></div></div></div>
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { personStatusEnum, orderStatusEnum, orderPaymentStatusEnum } from "@/app/enums/common"

	export default {
		name: "PersonGroupShow",
		data: () => ({
			data: [],
			customerID: null,
			agreementID: null,
			persongroupID: null,
			currentSort: "name",
			currentSortDir: "asc",
			searchSelection: "",
			pageSize: 10000,
			currentPage: 1
		}),
		beforeRouteUpdate(to, from, next)
		{
			this.findOrders()
			next()
		},
		props: ["search", "findorderinput"],
		computed:
		{
			findorderinputvalue: function ()
			{
				return this.findorderinput
			},
			isMobile()
			{
				return this.$mq !== "tablethori" && this.$mq !== "desktop"
			},
			sortedActivity: function ()
			{
				// TODO: Refactor til https://vuejs.org/v2/examples/grid-component.html

				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.sort((a, b) =>
				{
					let modifier = 1
					if (this.currentSortDir === 'desc') modifier = -1
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
					return 0
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize
					let end = this.currentPage * this.pageSize
					if (index >= start && index < end) return true
				})
			},
			filteredList()
			{
				if (!this.data || this.data.length == 0)
				{
					return []
				}

				var persons = this.data
				return persons.filter((data) =>
				{
					let name = data.name.toLowerCase().match(this.search.toLowerCase())
					return name
				}).filter((row, index) =>
				{
					let start = (this.currentPage - 1) * this.pageSize
					let end = this.currentPage * this.pageSize
					if (index >= start && index < end) return true
				})
			}
		},
		mounted()
		{
			this.agreementID = this.$route.params.agreementid
			this.customerID = this.$route.params.customerid
			this.persongroupID = this.$route.params.persongroupid

			if (this.$route.name == "FindOrdersResult")
			{
				this.findOrders()
			}
			else
			{
				this.loadData()
			}
		},
		methods:
		{
			markSearchText(text)
			{
				if (this.findorderinput && text.toLowerCase().indexOf(this.findorderinput.toLowerCase()) > -1)
				{
					var pattern = new RegExp(this.findorderinput, 'gi')
					text = text.replace(pattern, "<span class=\"highlight\">" + this.findorderinput.toUpperCase() + "</span>")
				}

				return text + "<div class=\"small\">" + "" + "</div>"
			},
			getOrderInfo(order)
			{
				if (order.status != orderStatusEnum.DRAFT)
				{
					var name = (order.ordername ? order.ordername + "<br />" : "")
					var email = (order.email ? order.email + "<br />" : "")
					var mobilenumber = (order.mobilenumber ? order.mobilenumber : "")
					return name + email + mobilenumber
				}
				else
				{
					return ""
				}
			},
			getPersonInfo(order)
			{
				return "<div class=\"small faded\">" + order.persongroupname + ", " + order.customername + "</div>"
			},
			getPersonStatus(person)
			{
				if (person.orders && person.orders.length > 0)
				{
					var completedOrder = person.orders.find(o => o.status == orderStatusEnum.COMPLETED);

					if (completedOrder)
					{
						return this.getOrderStatus(completedOrder)
					}
					/*else if (person.status != personStatusEnum.CANCELLED)
					{
						return this.getOrderStatus(person.orders[0])
					}*/
				}

				let text = ""
				let status = ""
				let dateHtml = ""
				let orderslastchangedate = person.orderslastchangedate ? new Date(person.orderslastchangedate) : null
				var options = { year: "numeric", month: "long", day: "numeric", time: "numeric", hour: "2-digit", minute: "2-digit" }

				switch (person.status)
				{
					case personStatusEnum.CREATED:
						text = "Kladde"
						status = "draft"
						break
					case personStatusEnum.READY:
						text = "Kan inviteres"
						status = "ready"
						break
					case personStatusEnum.READYCLIENTNOTIFIED:
						text = "Link sendt"
						status = "readyclientnotified"

						if (person.requestlinklastsent)
						{
							let date = new Date(person.requestlinklastsent)
							dateHtml = "Sendt " + date.toLocaleTimeString("da-dk", options)
						}

						break
					case personStatusEnum.CLIENTREQUESTEDRESHOOT:
						text = "Omfotografering"
						status = "clientrequestedreshoot"

						if (orderslastchangedate)
						{
							dateHtml = orderslastchangedate.toLocaleTimeString("da-dk", options)
						}

						break
					case personStatusEnum.CANCELLED:
						text = "Annulleret"
						status = "cancelled"

						if (orderslastchangedate)
						{
							dateHtml = orderslastchangedate.toLocaleTimeString("da-dk", options)
						}

						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>" + (dateHtml ? "<div class=\"small\">" + dateHtml + "</div>" : "")
			},
			getOrderStatus(order)
			{
				let text = ""
				let status = ""
				let dateHtml = ""
				let orderchangeddate = ""

				if (order.orderstatuschangeddate)
				{
					orderchangeddate = order.orderstatuschangeddate ? new Date(order.orderstatuschangeddate) : null
				}
				else if (order.statuschangeddate)
				{
					orderchangeddate = order.statuschangeddate ? new Date(order.statuschangeddate) : null
				}

				var options = { year: "numeric", month: "long", day: "numeric", time: "numeric", hour: "2-digit", minute: "2-digit" }

				switch (order.status)
				{
					case orderStatusEnum.DRAFT:
						text = "Kladde"
						status = "draft"
						break
					case orderStatusEnum.READY:
						text = "Oprettet"
						status = "ready"

						if (order.paymentreminder3lastsent && order.paymentreminder3fee && order.paymentreminder3fee > 0)
						{
							text = "Rykker 3"
							status = "paymentreminder"
							let paymentReminder3LastSent = new Date(order.paymentreminder3lastsent)
							dateHtml = "Rykker 3 sendt<br />" + paymentReminder3LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentreminder2lastsent && order.paymentreminder2fee && order.paymentreminder2fee > 0)
						{
							text = "Rykker 2"
							status = "paymentreminder"
							let paymentReminder2LastSent = new Date(order.paymentreminder2lastsent)
							dateHtml = "Rykker 2 sendt<br />" + paymentReminder2LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentreminder1lastsent && order.paymentreminder1lastsent >= order.paymentlinklastsent)
						{
							text = "Rykker 1"
							status = "paymentreminder"
							let paymentReminder1LastSent = new Date(order.paymentreminder1lastsent)
							dateHtml = "Rykker 1 sendt<br />" + paymentReminder1LastSent.toLocaleTimeString("da-dk", options)
						}
						else if (order.paymentlinklastsent)
						{
							text = "Betalingslink"
							status = "ready"
							let paymentLinkLastSent = new Date(order.paymentlinklastsent)
							dateHtml = "Betalingslink sendt<br />" + paymentLinkLastSent.toLocaleTimeString("da-dk", options)
						}

						break
					case orderStatusEnum.COMPLETED:

						if (order.paymentstatus == orderPaymentStatusEnum.SUCCEEDED)
						{
							if (order.paymentlinklastsent)
							{
								text = "Betalingslink"
							}
							else
							{
								text = "Betalt"
							}

							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.FREE)
						{
							text = "Gratis"
							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.AWAITING)
						{
							text = "Gennemført, ikke betalt"
							status = "completed"
						}
						else if (order.paymentstatus == orderPaymentStatusEnum.REJECTED)
						{
							text = "Afvist"
							status = "cancelled"
						}

						if (orderchangeddate)
						{
							dateHtml = orderchangeddate.toLocaleTimeString("da-dk", options)
						}

						break
					case orderStatusEnum.DELIVERED:
						text = "Sendt til kunde"
						status = "delivered"
						break
					case orderStatusEnum.REFUNDED:
						text = "Refunderet"
						status = "refunded"
						break
					default:
						text = "Ikke oprettet"
						status = "draft"
						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>" + (dateHtml ? "<div class=\"small\">" + dateHtml + "</div>" : "")
			},
			getOrderReminderFee(order)
			{
				if (order.paymentreminder3lastsent && order.paymentreminder3fee && order.paymentreminder3fee > 0)
				{
					return order.paymentreminder3fee
				}
				else if (order.paymentreminder2lastsent && order.paymentreminder2fee && order.paymentreminder2fee > 0)
				{
					return order.paymentreminder2fee
				}
				else if (order.paymentreminder1lastsent && order.paymentreminder1lastsent > order.paymentlinklastsent)
				{
					return order.paymentreminder1fee
				}

				return 0
			},
			getPayedPrice(person)
			{
				var total = 0

				if (person.orders.length > 0)
				{
					person.orders.forEach(order =>
					{
						if (order.status == orderStatusEnum.COMPLETED)
						{
							total = total + order.totalprice + this.getOrderReminderFee(order)
						}
					})

					return total + " kr."
				}

				return ""
			},
			getTotalPrice(order)
			{
				if (order.ordercount > 0)
				{
					return order.ordersum + " kr."
				}

				return ""
			},
			async loadData()
			{
				this.setComponentAsBusy()
				await this.$store.dispatch(types.ACTION_GET_ORDERS_BY_PERSONGROUP, { customerid: this.customerID, persongroupid: this.persongroupID })
					.then(response =>
					{
						this.data = response.data
						this.setComponentAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("PersonGroupShow.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			async findOrders()
			{
				this.setAppAsBusy()
				await this.$store.dispatch(types.ACTION_FIND_ORDERS, { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID, findorderinput: this.findorderinput })
					.then(response =>
					{
						this.data = response.data
						this.setAppAsIdle()
					})
					.catch(error =>
					{
						this.setAppAsIdle()
						logError("PersonGroupShow.findOrders()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					})
			},
			handlePersonOrders(person, event)
			{
				if (person.ordercount > 1)
				{
					let tableRow = event.target.parentElement

					if (tableRow)
					{
						tableRow.classList.toggle("toggled")
						const showOrders = tableRow.classList.contains("toggled")

						let orderFound = true

						while (orderFound)
						{
							tableRow = tableRow.nextSibling

							if (tableRow && (tableRow.classList && tableRow.classList.contains("multipleorderslist")))
							{
								if (showOrders)
									tableRow.classList.add("toggled")
								else
									tableRow.classList.remove("toggled")
							}
							else
							{
								orderFound = false
								break
							}
						}
					}
				}
				else
				{
					let url = this.$router.resolve({ name: "OrderEdit", params: { personid: person.id, persongroupid: this.persongroupID, orderid: person.firstorderid } }).href
					window.open(url, url);
				}
			},
			addOrder(person)
			{
				this.$router.push({ name: "OrderEdit", params: { personid: person.id, persongroupid: this.persongroupID, orderid: 0 } })
			},
			gotoOrder(order, personid)
			{
				this.$router.push({ name: "OrderEdit", params: { personid: personid, persongroupid: this.persongroupID, orderid: order.id } })
			},
			sort: function (s)
			{
				if (s === this.currentSort)
				{
					this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
				}
				this.currentSort = s
			},
			nextPage: function ()
			{
				if ((this.currentPage * this.pageSize) < this.data.length) this.currentPage++
			},
			prevPage: function ()
			{
				if (this.currentPage > 1) this.currentPage--
			}
		}
	}
</script>
